export default __webpack_public_path__ + "static/media/pve2.540be590.jpg";